// GENERATED by scripts/farm_backdrop.py from assets/farm-src/backdrop_anchors.json.
// w/h are DISPLAY px (the art is 2x); anchors are fractions of the sprite.
export const NEAR_OVERLAP = 24;
export const BAND_KEYS = { far: 'farm_bd_far', mid: 'farm_bd_mid', near: 'farm_bd_near' };
export const BD = {
  "farm_bd_far": {
    "w": 847.0,
    "h": 110.0
  },
  "farm_bd_mid": {
    "w": 593.0,
    "h": 80.0
  },
  "farm_bd_near": {
    "w": 318.0,
    "h": 75.0
  },
  "farm_bd_barn": {
    "w": 64.5,
    "h": 58.0,
    "windows": [
      [
        0.37,
        0.23,
        0.19,
        0.21
      ]
    ]
  },
  "farm_bd_farmhouse": {
    "w": 64.5,
    "h": 58.0,
    "chimney": [
      0.67,
      0.03
    ],
    "windows": [
      [
        0.34,
        0.31,
        0.11,
        0.15
      ],
      [
        0.12,
        0.63,
        0.1,
        0.16
      ],
      [
        0.57,
        0.63,
        0.11,
        0.16
      ],
      [
        0.79,
        0.62,
        0.07,
        0.16
      ]
    ]
  },
  "farm_bd_silo": {
    "w": 26.0,
    "h": 51.0
  },
  "farm_bd_windmill": {
    "w": 40.0,
    "h": 65.5,
    "hub": [
      0.46,
      0.19
    ]
  },
  "farm_bd_blades": {
    "w": 52.0,
    "h": 51.5
  },
  "farm_bd_tree_0": {
    "w": 56.0,
    "h": 62.0,
    "trunk": [
      0.5,
      0.97
    ]
  },
  "farm_bd_tree_1": {
    "w": 32.0,
    "h": 72.0,
    "trunk": [
      0.49,
      0.97
    ]
  },
  "farm_bd_tree_2": {
    "w": 56.0,
    "h": 62.5,
    "trunk": [
      0.5,
      0.96
    ]
  },
  "farm_bd_tree_3": {
    "w": 39.0,
    "h": 72.0,
    "trunk": [
      0.52,
      0.97
    ]
  },
  "farm_bd_cloud_0": {
    "w": 129.0,
    "h": 70.0
  },
  "farm_bd_cloud_1": {
    "w": 106.5,
    "h": 70.0
  },
  "farm_bd_cloud_2": {
    "w": 100.5,
    "h": 70.0
  },
  "farm_bd_cloud_3": {
    "w": 160.0,
    "h": 68.5
  },
  "farm_bd_cloud_4": {
    "w": 135.5,
    "h": 70.0
  },
  "farm_bd_sun": {
    "w": 96.0,
    "h": 94.5
  },
  "farm_bd_moon": {
    "w": 55.5,
    "h": 56.0,
    "disc": [
      0.5045,
      0.5,
      0.4414
    ]
  },
  "farm_bd_bird_0": {
    "w": 39.0,
    "h": 32.0
  },
  "farm_bd_bird_1": {
    "w": 39.0,
    "h": 32.0
  },
  "farm_bd_tuft_0": {
    "w": 34.0,
    "h": 24.0
  },
  "farm_bd_tuft_1": {
    "w": 32.0,
    "h": 24.0
  },
  "farm_bd_tuft_2": {
    "w": 31.5,
    "h": 24.0
  },
  "farm_bd_tuft_3": {
    "w": 32.5,
    "h": 24.0
  }
};
export const BD_KEYS = Object.keys(BD);
